<template>
  <div id="AssemblyRegister_main">
    <div
      v-if="canStartAssembly && canStartAssemblyShowAgain"
      class="tipsWindows"
    >
      <div class="title">
        已達到開會表決標準
      </div>
      <span>請點選下方【議案總表】查看可表決的議案，議案狀態為「已達門檻」即可點擊【表決】開始投票。</span>
      <div
        class="close-button"
        @click="canStartAssembly = false ; canStartAssemblyShowAgain = false"
      >
        <i
          class="icon-close"
          aria-hidden="true"
        />
      </div>
      <!-- <el-button class="topicPage-button" type="primary" round>前往表決
        <i class="icon-m-next" aria-hidden="true"></i>
      </el-button> -->
    </div>
    <div class="main">
      <div class="main-title">
        {{ dashboardData.title }}
      </div>
      <div
        id="attendance_table"
        class="main-subtitle"
      >
        區權人出席統計表
      </div>
      <div class="refresh">
        <div class="refreshTxt">
          統計最後更新時間：{{ refreshTime }}
        </div>
        <el-button
          type="success"
          icon="icon-refresh"
          size="mini"
          plain
          @click="refresh"
        >
          重新整理
        </el-button>
      </div>
      <RegisterDashboard
        :data="dashboardData"
        @refresh="refresh"
      />
      <el-button
        class="main-button"
        type="primary"
        round
        @click="$refs.registerDialog.openDialog('報到')"
      >
        批次報到
      </el-button>
      <el-button
        class="main-button"
        round
        @click="$refs.registerDialog.openDialog('簽退')"
      >
        批次簽退
      </el-button>
    </div>
    <div class="main">
      <div class="title_bar">
        <div class="left">
          <div class="title">
            會議資訊
          </div>
        </div>
      </div>
      <el-tabs v-model="activeName">
        <el-tab-pane
          label="住戶列表"
          name="1"
        >
          <RegisterList
            ref="registerList"
            :show-filter="true"
            :show-control-wrap="true"
            :show-button="true"
            :display-mode="0"
            :show-registration="true"
            @tablet-value-add="tabletValueAdd" @unregister-value-add="unregisterValueAdd" @cancel-register="cancelRegister" @cancel-unregistration="cancelUnregistration"
          />
        </el-tab-pane>
        <el-tab-pane
          label="議案總表"
          name="2"
        >
          <TopicOverView
            :main-threshold="dashboardData.threshold"
            :topic-list="topicList"
            :assembly-data="dashboardData"
            @refresh="getTopicList"
          />
        </el-tab-pane>
      </el-tabs>
    </div>
    <RegisterDialog
      ref="registerDialog"
      @tablet-value-dashboard-add="tabletValueDashboardAdd"
      @unregister-value-dashboard-add="unregisterValueDashboardAdd"
    />
  </div>
</template>
<script>
import RegisterDashboard from './components/RegisterDashboard'
import RegisterList from './components/RegisterList'
import RegisterDialog from './components/RegisterDialog'
import TopicOverView from './components/topicOverView/TopicOverView'

export default {
  components: {
    RegisterDashboard,
    RegisterList,
    RegisterDialog,
    TopicOverView
  },
  beforeRouteLeave (to, from, next) {
    clearInterval(this.timer)
    next()
  },
  data () {
    return {
      canStartAssembly: false,
      canStartAssemblyShowAgain: true,
      dashboardData: {},
      refreshTime: '',
      topicList: [],
      timer: null,
      tipsWindowsOpen: false,
      activeName: '1'
    }
  },
  mounted () {
    this.getDashboardData()
    this.getTopicList()
    this.calculateThreshold()
    this.openRefreshTimer()
  },
  methods: {
    getDashboardData () {
      apiUnitOwnerAssembly.GetDashboardData(
        {
          AssemblyId: this.$route.params.id
        }
      ).then(res => {
        // eslint-disable-next-line eqeqeq
        if (res.status == 200) {
          this.refreshTime = this.$newFormatDate(new Date())
          res.data.tabletThreshold = Math.ceil(res.data.tabletTotal * res.data.threshold)
          res.data.areaThreshold = Math.ceil(res.data.areaTotal * res.data.threshold)
          this.dashboardData = res.data
          this.calculateThreshold()
        }
      }).catch((err) => {
        console.log('錯誤訊息：', err.response)
      })
    },
    // 取得議案
    getTopicList () {
      apiUnitOwnerAssembly.Topic.GetTopicList(
        {
          AssemblyId: this.$route.params.id
        }
      ).then(res => {
        this.topicList = []
        this.topicList = res.data
        this.topicList.forEach(item => {
          item.canVoteThreshold = false
        })
        this.calculateThreshold()
      }).catch((err) => {
        console.log('錯誤訊息：', err.response)
      })
    },
    // 重新取得
    refresh () {
      this.getDashboardData()
      this.$refs.registerList.getListData()
      this.calculateThreshold()
      this.getTopicList()
    },
    // 報到，增加實到人數
    tabletValueAdd (item) {
      console.log('報到', item)
      this.dashboardData.tabletValue++
      if (this.dashboardData.useArea) { this.dashboardData.areaValue = this.dashboardData.areaValue + item.tabletArea }
      this.calculateThreshold()
    },
    // 簽退，增加已簽退人數
    unregisterValueAdd () {
      this.dashboardData.unregisterValue++
    },
    // 批次報到
    tabletValueDashboardAdd (id, identity) {
      console.log('報到頁  批次報到')
      this.$refs.registerList.tabletValueAdd(id, identity)
    },
    // 批次簽退
    unregisterValueDashboardAdd (id) {
      this.$refs.registerList.unregisterValueAdd(id)
    },
    // 取消報到
    cancelRegister (tabletArea) {
      this.dashboardData.areaValue = this.dashboardData.areaValue - tabletArea
      this.dashboardData.tabletValue--
    },
    // 取消簽退
    cancelUnregistration () {
      this.dashboardData.unregisterValue--
    },
    calculateThreshold () {
      // 計算會議門檻
      // eslint-disable-next-line eqeqeq
      if (this.dashboardData.status == 'Started') {
        this.canStartAssembly = false
      } else {
        this.canStartAssembly = false
        if (this.dashboardData.useTablet && this.dashboardData.useArea) {
          this.canStartAssembly = this.dashboardData.tabletValue >= this.dashboardData.tabletThreshold
          this.canStartAssembly = this.dashboardData.areaValue >= this.dashboardData.areaThreshold
        } else {
          if (this.dashboardData.useTablet) { this.canStartAssembly = this.dashboardData.tabletValue >= this.dashboardData.tabletThreshold } else { this.canStartAssembly = this.dashboardData.areaValue >= this.dashboardData.areaThreshold }
        }
      }
      // 計算議案門檻
      this.topicList.forEach(topic => {
        // 各議案人數出席門檻
        // eslint-disable-next-line eqeqeq
        if (topic.progressStatus == 'notmet') {
          const tabletThreshold = Math.ceil(this.dashboardData.tabletTotal * topic.attendanceThreshold)
          const areaThreshold = Math.ceil(this.dashboardData.areaTotal * topic.attendanceThreshold)
          if (this.dashboardData.useTablet && this.dashboardData.useArea) {
            topic.canVoteThreshold = this.dashboardData.tabletValue >= tabletThreshold
            topic.canVoteThreshold = this.dashboardData.areaValue >= areaThreshold
          } else {
            if (this.dashboardData.useTablet) { topic.canVoteThreshold = this.dashboardData.tabletValue >= tabletThreshold } else { topic.canVoteThreshold = this.dashboardData.areaValue >= areaThreshold }
          }
          if (topic.canVoteThreshold) { topic.progressStatus = 'met' }
        }
      })
    },
    // 刷新倒數計時器
    openRefreshTimer () {
      let time = 10000
      this.timer = setInterval(() => {
        if (!(this.$refs.registerDialog && this.$refs.registerDialog.dialogVisible || this.$refs.registerList && this.$refs.registerList.canOpenRefreshTimer())) {
          this.refresh()
          time = 10000
        } else {
          time = 100
        }
      }, time)
    }
  }
}
</script>
<style lang="sass" scoped>
#AssemblyRegister_main
  +mainLayer
  padding-top: 24px
  .tipsWindows
    max-width: 98%
    margin: 0 auto 16px
    padding: 12px
    background-color: $white
    box-shadow: 0 0 5px rgba(0, 0, 0, 0.1)
    border-radius: $pageBorderRadius
    box-sizing: border-box
    position: relative
    .title
      font-size: 25px
      color: $mainColor
      font-weight: 600
      line-height: 35px
      margin-bottom: 8px
    span
      font-size: 17px
      line-height: 24px
    .close-button
      cursor: pointer
      position: absolute
      top: 10px
      right: 15px
      background-color: $bgDark3
      padding: 6px
      border-radius: 50%
      width: 15px
      height: 15px
    .topicPage-button
      position: absolute
      top: 40px
      right: 60px
      .icon-m-next
        font-size: 10px
        padding-right: 0
  .main
    margin-bottom: 30px
    position: relative
    .main-title
      word-wrap: break-word
      font-size: 25px
      font-weight: bold
      line-height: 50px
    .main-subtitle
      font-size: 21px
    .refresh
      margin: 15px
      font-size: 17px
      color: $subFontColor
      .refreshTxt
        display: inline-block
        line-height: 32px
        margin-right: 8px
        position: relative
        top: 1px
    .dialog-button
      position: absolute
      right: 30px
      top: 110px
    .main-button
      margin: 20px 10px 0 10px
      font-size: 20px
      line-height: 40px
      border-radius: 50px
    ::v-deep .el-tabs
      +basicTabs
  ::v-deep .topicList
    +basicDialog
</style>
